import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import LoginView from '@/views/LoginView.vue'
import IafCertSearchView from '@/views/IafCertSearchView.vue'

const PUBLIC_PATHS = ['/login', '/', '/customer/apply', '/search/auditor']
const SESSION_EXPIRED_MESSAGE = '로그인 세션이 만료되었습니다. 다시 로그인해주세요.'
const SESSION_CHECK_INTERVAL_MS = 60 * 1000
let lastSessionCheckAt = 0

const normalizeSessionUser = (user = {}) => ({
  name: user.name,
  email: user.email,
  role: user.role,
  id: user.id,
  code: user.code,
  yn: user.yn,
  grade: user.grade,
  ai_report_yn: user.ai_report_yn
})

const notifyExpiredSession = () => {
  if (window.__kaicmsSessionExpiredNotified) return
  window.__kaicmsSessionExpiredNotified = true
  alert(SESSION_EXPIRED_MESSAGE)
}

const fetchSessionStatus = async (force = false) => {
  const now = Date.now()
  if (!force && store.getters['user/isLogin'] && now - lastSessionCheckAt < SESSION_CHECK_INTERVAL_MS) {
    return { authenticated: true, user: store.state.user.userInfo }
  }

  const response = await fetch('/api/session', {
    credentials: 'include',
    headers: { Accept: 'application/json' }
  })
  lastSessionCheckAt = now
  return await response.json()
}

const routes = [
  // {
  //   path: '/',
  //   name: 'login',
  //   component: LoginView
  // },
  {
    path: '/',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/HomeView.vue')
  },
  {
    path: '/iaf-cert-search',
    name: 'IafCertSearch',
    component: IafCertSearchView
  },
  // {
  //   path: '/dashboard',
  //   name: 'dashboard',
  //   component: () =>
  //     import(/* webpackChunkName: "mgt" */ '../views/DashBoardView.vue')
  // },

  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/auditor',
    name: 'auditor',
    component: () =>
      import(/* webpackChunkName: "auditor" */ '../views/AuditorView.vue')
  },

  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/hello',
    name: 'hello',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/HelloView.vue')
  },
  {
    path: '/user/create',
    name: 'userCreateView',
    component: () =>
      import(/* webpackChunkName: "user" */ '../views/userCreateView.vue')
  },
  {
    path: '/user/detail',
    name: 'userDetailView',
    component: () =>
      import(/* webpackChunkName: "user" */ '../views/userDetailView.vue')
  },
  {
    path: '/user/change',
    name: 'userChangeView',
    component: () =>
      import(/* webpackChunkName: "user" */ '../views/userChangeView.vue')
  },
  {
    path: '/customer/create',
    name: 'customerCreate',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '../views/CustomerCreateView.vue'
      )
  },
  // {
  //   path: '/customer/list',
  //   name: 'customerList',
  //   component: () =>
  //     import(/* webpackChunkName: "customer" */ '../views/CustomerListView.vue')
  // },
  {
    path: '/customer/list/auditor',
    name: 'CustomerListByAuditor',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '../views/CustomerListByAuditorView.vue'
      )
  },
  {
    path: '/customer/detail',
    name: 'customerDetail',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '../views/CustomerDetailView.vue'
      )
  },
  {
    path: '/customer/change',
    name: 'CustomerChangeView',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '../views/CustomerChangeView.vue'
      )
  },
  // {
  //   path: '/customer/cert/',
  //   name: 'CertCreateView',
  //   component: CertCreateView,
  //   props: true
  // },
  {
    path: '/customer/apply',
    name: 'ApplyAuditView',
    component: () =>
      import(/* webpackChunkName: "cert" */ '../views/ApplyAuditView.vue')
  },
  {
    path: '/customer/cert',
    name: 'CertCreateView',
    component: () =>
      import(/* webpackChunkName: "cert" */ '../views/CertCreateView.vue')
  },
  {
    path: '/customer/cert/change',
    name: 'CertChangeView',
    component: () =>
      import(/* webpackChunkName: "cert" */ '../views/CertChangeView.vue')
  },

  {
    path: '/customer/cert/list',
    name: 'AuditListView',
    component: () =>
      import(/* webpackChunkName: "cert" */ '../views/AuditListView.vue')
  },
  {
    path: '/customer/cert/detail',
    name: 'AuditDetailView',
    component: () =>
      import(/* webpackChunkName: "cert" */ '../views/AuditDetailView.vue')
  },

  {
    path: '/customer/cr',
    name: 'CustomerDoCRView',
    component: () =>
      import(/* webpackChunkName: "cr" */ '../views/CustomerDoCRView.vue')
  },
  {
    path: '/customer/cr/list',
    name: 'CRListView',
    component: () =>
      import(/* webpackChunkName: "cr" */ '../views/CRListView.vue')
  },
  {
    path: '/customer/cr/detail',
    name: 'CrDetailView',
    component: () =>
      import(/* webpackChunkName: "cr" */ '../views/CrDetailView.vue')
  },
  {
    path: '/customer/application-rejections',
    name: 'ApplicationRejectionListView',
    component: () =>
      import(/* webpackChunkName: "cr" */ '../views/ApplicationRejectionListView.vue')
  },
  // {
  //   path: '/admin/list',
  //   name: 'adminView',
  //   component: () =>
  //     import(/* webpackChunkName: "admin" */ '../views/AdminView.vue')
  // },
  {
    path: '/report/trans',
    name: 'ReportTransView',
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/ReportTransView.vue')
  },
  // {
  //   path: '/report/s1/v2',
  //   name: 'ReportS1NewView',
  //   component: () =>
  //     import(/* webpackChunkName: "report" */ '../views/ReportS1NewView.vue')
  // },
  {
    path: '/report/s1/v3',
    name: 'ReportS1ViewV3',
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/ReportS1ViewV3.vue')
  },
  // {
  //   path: '/report/new/s2',
  //   name: 'ReportS2ViewNew',
  //   component: () =>
  //     import(/* webpackChunkName: "report" */ '../views/ReportS2ViewNew.vue')
  // },
  {
    path: '/report/s2/v3',
    name: 'ReportS2ViewV3',
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/ReportS2ViewV3.vue')
  },
  {
    path: '/report/contract',
    name: 'ContractView',
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/ContractView.vue')
  },
  {
    path: '/report/audit/plan',
    name: 'AuditPlanView',
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/AuditPlanView.vue')
  },
  {
    path: '/report/list',
    name: 'ReportListView',
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/ReportListView.vue')
  },
  {
    path: '/upload/list',
    name: 'UploadReportListView',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/UploadReportListView.vue'
      )
  },
  {
    path: '/report/trans/detail',
    name: 'ReportTransDetailView',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/ReportTransDetailView.vue'
      )
  },
  {
    path: '/report/trans/change',
    name: 'ReportTransChangeView',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/ReportTransChangeView.vue'
      )
  },

  // {
  //   path: '/report/s1/detail',
  //   name: 'ReportS1DetailView',
  //   component: () =>
  //     import(/* webpackChunkName: "report" */ '../views/ReportS1DetailView.vue')
  // },
  // {
  //   path: '/report/s1/change',
  //   name: 'ReportS1ChangeView',
  //   component: () =>
  //     import(/* webpackChunkName: "report" */ '../views/ReportS1ChangeView.vue')
  // },
  // {
  //   path: '/report/s1/v2/detail',
  //   name: 'ReportS1DetailViewV2',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "report" */ '../views/ReportS1DetailViewV2.vue'
  //     )
  // },
  {
    path: '/report/s1/v3/detail',
    name: 'ReportS1DetailViewV3',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/ReportS1DetailViewV3.vue'
      )
  },
  {
    path: '/report/s1/detail',
    name: 'ReportS1DetailViewLegacyRedirect',
    redirect: (to) => ({
      path: '/report/s1/v3/detail',
      query: to.query
    })
  },
  // {
  //   path: '/report/s1/v2/change',
  //   name: 'ReportS1ChangeViewV2',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "report" */ '../views/ReportS1ChangeViewV2.vue'
  //     )
  // },
  {
    path: '/report/s1/v3/change',
    name: 'ReportS1ChangeViewV3',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/ReportS1ChangeViewV3.vue'
      )
  },
  // {
  //   path: '/report/s2/new/detail',
  //   name: 'ReportS2DetailNewView',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "report" */ '../views/ReportS2DetailNewView.vue'
  //     )
  // },
  {
    path: '/report/s2/v3/detail',
    name: 'ReportS2DetailViewV3',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/ReportS2DetailViewV3.vue'
      )
  },
  {
    path: '/report/s2/detail',
    name: 'ReportS2DetailViewLegacyRedirect',
    redirect: (to) => ({
      path: '/report/s2/v3/detail',
      query: to.query
    })
  },
  // {
  //   path: '/report/s2/new/change',
  //   name: 'ReportS2ChangeNewView',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "report" */ '../views/ReportS2ChangeNewView.vue'
  //     )
  // },
  {
    path: '/report/s2/v3/change',
    name: 'ReportS2ChangeViewV3',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/ReportS2ChangeViewV3.vue'
      )
  },
  {
    path: '/upload/trans',
    name: 'UploadTransView',
    component: () =>
      import(/* webpackChunkName: "upload" */ '../views/UploadTransView.vue')
  },

  {
    path: '/upload/s1',
    name: 'UploadS1View',
    component: () =>
      import(/* webpackChunkName: "upload" */ '../views/UploadS1View.vue')
  },

  {
    path: '/upload/s2',
    name: 'UploadS2View',
    component: () =>
      import(/* webpackChunkName: "upload" */ '../views/UploadS2View.vue')
  },
  {
    path: '/upload/detail/trans',
    name: 'UploadTransDetailView',
    component: () =>
      import(
        /* webpackChunkName: "upload" */ '../views/UploadTransDetailView.vue'
      )
  },
  {
    path: '/upload/detail/s1',
    name: 'UploadS1DetailView',
    component: () =>
      import(/* webpackChunkName: "upload" */ '../views/UploadS1DetailView.vue')
  },
  {
    path: '/upload/detail/s2',
    name: 'UploadS2DetailView',
    component: () =>
      import(/* webpackChunkName: "upload" */ '../views/UploadS2DetailView.vue')
  },
  {
    path: '/upload/trans/change',
    name: 'UploadTransChangeView',
    component: () =>
      import(
        /* webpackChunkName: "upload" */ '../views/UploadTransChangeView.vue'
      )
  },
  {
    path: '/upload/s1/change',
    name: 'UploadS1ChangeView',
    component: () =>
      import(/* webpackChunkName: "upload" */ '../views/UploadS1ChangeView.vue')
  },
  {
    path: '/upload/s2/change',
    name: 'UploadS2ChangeView',
    component: () =>
      import(/* webpackChunkName: "upload" */ '../views/UploadS2ChangeView.vue')
  },
  {
    path: '/mgt/signal',
    name: 'AuditSignalRampView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/AuditSignalRampView.vue')
  },
  {
    path: '/mgt/tax',
    name: 'TaxInvoiceCreateView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/TaxInvoiceCreateView.vue')
  },
  {
    path: '/mgt/tax/detail',
    name: 'TaxInvoiceDetailView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/TaxInvoiceDetailView.vue')
  },
  {
    path: '/mgt/tax/change',
    name: 'TaxInvoiceChangeView',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/TaxInvoiceChangeView.vue'
      )
  },
  {
    // 세금계산서 발행 승인 대기 (2026-09-09 승인 후 발행 전환).
    //
    // **상단 메뉴에 넣지 않는다.** 메뉴가 이미 많아 폭이 좁아지면 줄바꿈되면서
    // 메뉴 영역이 아래 본문을 가린다(소유자 판정 2026-09-09).
    // 유일한 진입 경로는 승인 대기 알림 메일의 링크다 —
    // utils/autoTaxInvoiceCron.js 의 sendPendingAlert() 와 다이제스트 헤더.
    // 그래서 비로그인 상태로 링크를 타고 들어와도 로그인 후 이 화면으로
    // 돌아와야 한다(아래 beforeEach 의 redirect 처리).
    path: '/mgt/tax/approval',
    name: 'TaxInvoiceApprovalView',
    meta: { adminEmailOnly: true },
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/TaxInvoiceApprovalView.vue')
  },
  {
    path: '/mgt/tax/amend',
    name: 'TaxInvoiceAmendView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/TaxInvoiceAmendView.vue')
  },
  {
    path: '/mgt/fee',
    name: 'CashCreateView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/CashCreateView.vue')
  },
  {
    path: '/mgt/payment',
    name: 'PaymentCreateView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/PaymentCreateView.vue')
  },
  {
    path: '/mgt/payment/detail',
    name: 'PaymentDetailView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/PaymentDetailView.vue')
  },
  {
    path: '/mgt/payment/change',
    name: 'PaymentChangeView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/PaymentChangeView.vue')
  },

  {
    path: '/mgt/cash-income',
    name: 'CashIncomeDashboardView',
    meta: { adminEmailOnly: true },
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/CashIncomeDashboardView.vue')
  },

  {
    path: '/mgt/online-applications',
    name: 'OnlineApplicationListView',
    meta: { requiresAdmin: true },
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/OnlineApplicationListView.vue')
  },

  {
    path: '/mgt/fee/detail',
    name: 'CashDetailView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/CashDetailView.vue')
  },
  {
    path: '/mgt/fee/change',
    name: 'CashChangeView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/CashChangeView.vue')
  },
  {
    path: '/mgt/upload/cert',
    name: 'UploadCertCreateView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/UploadCertCreateView.vue')
  },
  {
    path: '/mgt/upload/cert/detail',
    name: 'UploadCertDetailView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/UploadCertDetailView.vue')
  },
  {
    path: '/mgt/upload/cert/change',
    name: 'UploadCertChangeView',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/UploadCertChangeView.vue'
      )
  },
  {
    path: '/mgt/pw/change',
    name: 'PwChangeView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/PwChangeView.vue')
  },
  {
    path: '/mgt/issue/cert',
    name: 'IssueCertView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/IssueCertView.vue')
  },
  {
    path: '/mgt/reissue/cert',
    name: 'ReIssueCertView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/ReIssueCertView.vue')
  },
  {
    path: '/mgt/reissue/detail',
    name: 'ReIssueCertDetailView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/ReIssueCertDetailView.vue')
  },
  {
    path: '/mgt/cert/detail',
    name: 'IssueCertDetailView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/IssueCertDetailView.vue')
  },
  {
    path: '/mgt/cert/change',
    name: 'IssueCertChangeView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/IssueCertChangeView.vue')
  },
  {
    path: '/mgt/reissue/change',
    name: 'ReIssueCertChangeView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/ReIssueCertChangeView.vue')
  },
  {
    path: '/mgt/cert/status/change',
    name: 'StatusCertChangeView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/StatusCertChangeView.vue')
  },
  {
    // 옛 임시저장 화면. report_s2_new 를 그대로 편집하면서도 현장순회 체크리스트 UI 가
    // 없어, V3 에서 만든 체크리스트를 열 수 없고 검증 없이 최종저장까지 되던 화면이다.
    // 북마크·직접입력으로도 들어오지 못하게 V3 수정화면으로 넘긴다.
    path: '/report/new/s2/temp',
    name: 'ReportS2TempViewNewLegacyRedirect',
    redirect: (to) => ({
      path: '/report/s2/v3/change',
      query: to.query
    })
  },
  {
    path: '/mgt/change/cert',
    name: 'ApplyChangeCertView',
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/ApplyChangeCertView.vue'
      )
  },
  {
    path: '/search/auditor',
    name: 'SearchAuditorView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/SearchAuditorView.vue')
  },
  {
    path: '/mgt/announcement',
    name: 'AnnouncementMgtView',
    component: () =>
      import(/* webpackChunkName: "mgt" */ '../views/AnnouncementMgtView.vue')
  },
  {
    path: '/mgt/notification',
    name: 'NotificationView',
    component: () =>
      import(/* webpackChunkName: "notification" */ '../views/NotificationView.vue')
  },
  {
    path: '/mgt/monitoring',
    name: 'MonitoringDashboardView',
    component: () =>
      import(/* webpackChunkName: "monitoring" */ '../views/MonitoringDashboardView.vue')
  },
  {
    path: '/mgt/monitoring/history',
    name: 'MonitoringHistoryView',
    component: () =>
      import(/* webpackChunkName: "monitoring" */ '../views/MonitoringHistoryView.vue')
  },
  {
    path: '/mgt/monitoring/run',
    name: 'MonitoringRunView',
    component: () =>
      import(/* webpackChunkName: "monitoring" */ '../views/MonitoringRunView.vue')
  },
  {
    // 인증유지 설문 현황(조회 전용). 별도 chunk 로 지연 로딩한다 — 공통 묶음을 키우지 않는다.
    path: '/mgt/renewal',
    name: 'RenewalAdminView',
    component: () =>
      import(/* webpackChunkName: "renewal-admin" */ '../views/RenewalAdminView.vue')
  },
  {
    path: '/mgt/audit-eligibility',
    name: 'AuditEligibilityView',
    component: () =>
      import(/* webpackChunkName: "audit-eligibility" */ '../views/AuditEligibilityView.vue')
  },
  {
    path: '/mgt/contract-review/bulk',
    name: 'CrBulkExportView',
    component: () =>
      import(/* webpackChunkName: "cr" */ '../views/CrBulkExportView.vue')
  },
  {
    path: '/cert-decision',
    name: 'CertDecision',
    component: () => import('@/views/CertDecisionView.vue')
  },
  // 고객이 메일 링크로 들어오는 비로그인 공개 라우트. 가드는 접두 매칭으로 통과시킨다(아래 beforeEach 참고).
  {
    path: '/renewal/r/:token',
    name: 'RenewalResponseView',
    component: () =>
      import(/* webpackChunkName: "renewal" */ '../views/RenewalResponseView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

const adminEmailOnlyPaths = [
  '/iaf-cert-search',
  '/mgt/cash-income',
  '/mgt/tax/amend'
]

const adminOnlyPaths = [
  '/auditor',
  '/user/create',
  '/customer/cr',
  '/customer/cr/list',
  '/customer/cr/detail',
  '/mgt/tax',
  '/mgt/tax/detail',
  '/mgt/tax/change',
  '/mgt/fee',
  '/mgt/payment',
  '/mgt/payment/change',
  '/mgt/upload/cert',
  '/mgt/upload/cert/detail',
  '/mgt/upload/cert/change',
  '/mgt/issue/cert',
  '/mgt/reissue/cert',
  '/mgt/reissue/detail',
  '/mgt/cert/detail',
  '/mgt/cert/change',
  '/mgt/reissue/change',
  '/mgt/cert/status/change',
  '/mgt/announcement',
  '/mgt/notification',
  '/mgt/monitoring',
  '/mgt/monitoring/history',
  '/mgt/monitoring/run',
  '/mgt/renewal',
  '/mgt/audit-eligibility',
  '/mgt/contract-review/bulk',
  '/cert-decision',
  '/mgt/online-applications'
]

function isAdminEmailOnlyRoute(path, routeMeta) {
  return routeMeta.adminEmailOnly || adminEmailOnlyPaths.includes(path)
}

function isAdminOnlyRoute(path, routeMeta) {
  return routeMeta.requiresAdmin || adminOnlyPaths.includes(path)
}

// ==라우터 네비게이션 ==============================
router.beforeEach(async (to, from, next) => {
  // PUBLIC_PATHS 는 완전일치라 /renewal/r/:token 같은 동적 파라미터 공개 라우트를 통과시키지 못한다.
  // 그래서 접두 매칭을 함께 본다. (SPEC §C-4 / CONTRACT §5-4)
  if (PUBLIC_PATHS.includes(to.path) || /^\/renewal\/r\//.test(to.path)) {
    next()
  } else {
    try {
      const session = await fetchSessionStatus()
      if (!session.authenticated) {
        store.commit('user/logout')
        notifyExpiredSession()
        // 원래 가려던 곳을 들고 간다 — 메일 링크로 들어온 관리자가 로그인 뒤
        // 엉뚱한 화면에 떨어지지 않게. (세금계산서 승인 화면은 메뉴가 없어
        // 이 경로가 유일한 입구다.)
        next({ path: '/login', query: { expired: '1', redirect: to.fullPath } })
        return
      }
      if (session.user && session.user.email && !store.state.user.userInfo.email) {
        store.commit('user/setUser', normalizeSessionUser(session.user))
      }
      const userInfo = store.state.user.userInfo
      if (isAdminEmailOnlyRoute(to.path, to.meta) && userInfo.email !== 'admin@kaicert.com') {
        alert('admin@kaicert.com 계정만 접근할 수 있습니다.')
        next('/mgt/signal')
        return
      }
      if (isAdminOnlyRoute(to.path, to.meta) && userInfo.email !== 'admin@kaicert.com' && userInfo.role !== 'admin') {
        alert('관리자만 접근할 수 있습니다.')
        next('/mgt/signal')
        return
      }
      next()
    } catch (error) {
      if (store.getters['user/isLogin']) {
        next()
        return
      }
      store.commit('user/logout')
      next('/login')
    }
  }
})
//   //     next()
//   //   }
//   // } else {
//   //   return next({ path: '/login' })
//   // }

// if (to.path === '/') {
//   next()
// } else {
//   if (isLogin) {
//     next()
//   } else {
//     // store.commit('user/logout')
//     next('/login')
//   }
// }

export default router
